angular.module('app').controller('PracticeTermsModalCtrl',
    ['$scope', '$uibModalInstance', '$sce', 'ConsentService', 'LocalStorageRepository',
        function ($scope, $modalInstance, $sce, ConsentService, LocalStorageRepository) {
            'use strict';

            $scope.loading = true;
            var loginUserId = LocalStorageRepository.getUserID();

            function loadPracticeTerms() {
                $scope.loading = true;
                $scope.removeHttpError();

                if (loginUserId) {
                    ConsentService.getPracticeConsent()
                        .then(function (data) {
                            $scope.practiceConsent = data.ConsentForm;
                        })
                        .catch(function (response) {
                            $scope.addHttpError(response);
                        })
                        .finally(function () {
                            $scope.loading = false;
                        });
                } else {
                    $scope.loading = false;
                }
            }

            function ok() {
                $modalInstance.close('ok');
            }

            function cancel() {
                $modalInstance.dismiss('cancel');
            }

            $scope.ok = ok;
            $scope.cancel = cancel;

            loadPracticeTerms();
        }]);